<template>
    <div class="scroll_wrap" style=" "><slot></slot></div>
</template>

<script>
    export default {
        name: "HorizonScrollWrap"
    }
</script>

<style scoped>
    .scroll_wrap{
        overflow-x: auto;white-space: nowrap;    width: calc(100%); padding:5px 10px;
        overflow-y: hidden;

    }
    .scroll_wrap::-webkit-scrollbar {
        display: none; /* Chrome, Safari, Opera*/

    }
</style>